import React, { useState } from 'react';
import { Grid, Box, Link } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

const ContentTitleField = ({ content, setContent }: any) => {
    const [title, setTitle] = useState(content.title || '');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newTitle = e.target.value;
        setTitle(newTitle);
        // Update contentData with the new title
        setContent((prevContentData: any) => ({
            ...prevContentData,
            title: newTitle,
        }));

    };


    return (
        <Grid display={"flex"} gap={5} flexDirection={"column"} p={{ xs: 2, md: 5 }} mt={{ xs: 3, md: 0 }}>
            <Grid item xs={12} sm={6} gap={1} display={"flex"} flexDirection={"column"}>
                <label
                    htmlFor="summary"
                    style={styleSheet.labelText}
                >
                    Please enter a title for your content
                </label>
                <Grid display={"flex"} gap={2} alignItems={"center"} flex={1}>
                    <Box sx={{ flexGrow: 1 }}>
                        <CustomTextField
                            name="title"
                            multiline
                            rows={2}
                            sx={{
                                width: '100%', maxWidth: '654px',

                            }}
                            value={title}
                            onChange={handleChange}
                        />
                    </Box>
                </Grid>
            </Grid>

        </Grid>
    );
};

export default ContentTitleField;
const styleSheet = {
    labelText: {
        fontWeight: 400, fontSize: "17px", color: "#000000",
    }
}